// extracted by mini-css-extract-plugin
export var acceptButton = "_15-5";
export var fullContent = "_15-4";
export var link = "_15-6";
export var linkIcon = "_15-7";
export var sideContent = "_15-3";
export var sideImage = "_15-2";
export var sideImageWrapper = "_15-1";
export var splitLayout = "_15-0";